// extracted by mini-css-extract-plugin
export default {"icon":"SearchContactTextInput_icon__YbekQ","fub":"SearchContactTextInput_fub__40eXW","nekst":"SearchContactTextInput_nekst__MdaG6"};